// extracted by mini-css-extract-plugin
export default {"actions":"styles_actions__pcj2J","tag":"styles_tag__qEAzq"};